<div class="list-card row">
  <div class="col-md-12">
    <nb-card>
      <table [nbSpinner]="loading" nbSpinnerStatus="info">
        <tr *ngFor="let itemL of lectures; let i = index">
          <td>
            <nb-actions size="medium">
              <nb-action (click)="openSourceContent(itemL)" class="nbaction">
                <nb-icon
                  *ngIf="
                    itemL.status == 1 &&
                    !itemL.privacy &&
                    itemL.sourceType == 'video'
                  "
                  class="action-icon"
                  icon="play-circle-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="
                    itemL.status == 1 &&
                    !itemL.privacy &&
                    itemL.sourceType == 'images'
                  "
                  class="action-icon"
                  icon="image-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="
                    itemL.status == 1 &&
                    !itemL.privacy &&
                    itemL.sourceType == 'document'
                  "
                  class="action-icon"
                  icon="file-text-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="
                    itemL.status == 1 &&
                    !itemL.privacy &&
                    itemL.sourceType == 'live'
                  "
                  class="action-icon"
                  icon="video-outline"
                ></nb-icon>
                <nb-icon
                  *ngIf="
                    itemL.status != 1 ||
                    itemL.privacy ||
                    itemL.sourceType === ''
                  "
                  class="action-icon"
                  icon="eye-off-outline"
                ></nb-icon>
                <span> {{ i + 1 }}: {{ itemL.title }}</span>
              </nb-action>
            </nb-actions>
          </td>
        </tr>
      </table>
    </nb-card>
  </div>
</div>
